module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/05-5d677aed3209a7fa578ca47ee6540def.jpg";